define('viewmodels/pages/cash/AmountStepViewModel',['underscore', 'knockout', 'common/model/Cash'], function (_, ko, Cash) {

    function AmountStepViewModel(formFields, wrappedPlayer, page, isManualModeEnabled, paymentModel) {

        var player = wrappedPlayer.peek(),
            summary = page.findFieldByName('amount_summary'),
            summaryWithBonus = page.findFieldByName('amount_summary_when_bonus_active'),
            disposables = [],
            self = this;

        this.field = formFields.cashField( paymentModel.amount );
        this.label = page.findFieldByName('amount_label');
        this.smallInfo = page.findFieldByName('amount_small_info');
        this.type = 'amount';
        this.summary = ko.pureComputed(function() {

            if (paymentModel.bonusAmount && paymentModel.bonusAmount() > 0) {
                return summaryWithBonus();
            }

            return summary();
        });
        this.wagerLabel = page.findFieldByName('remaining_wager');
        this.feePercentage = paymentModel.feePercentage;
        this.amount = paymentModel.amount;
        this.bonusAmount = paymentModel.bonusAmount;
        this.totalAmount = paymentModel.totalAmount;
        this.balance = player.wallet.balance.property('amount');
        this.bonusBalance = player.bonus.balance.property('amount');
        this.realBalance = player.realMoney.property('amount');
        this.wagerAmount = player.bonus.wageringRequirement.property('amount');

        this.isManualModeEnabled = isManualModeEnabled;

        this.isManualMode = ko.pureComputed({
            owner: ko.observable(false),
            read: function () {
                return this();
            },
            write: function (value) {

                if (value === true) {
                    paymentModel.amount(null);
                }

                this(value);
            }
        });

        this.suggestedAmounts = paymentModel.suggestedAmounts.map(function (value) {
            return {
                value: value,
                select: function () {
                    paymentModel.amount(new Cash(value));
                },
                isSelected: ko.pureComputed(function () {
                    return paymentModel.amount() === value;
                })
            };
        });

        this.attached = function () {
            disposables.push(paymentModel.amount.isBad.subscribeAndExec(function (isBad) {
                if (isBad && !self.isManualMode()) {
                    paymentModel.amount(new Cash(paymentModel.suggestedAmount()));
                }
            }));
        };

        this.detached = function () {
            _.invokeMap(disposables, 'dispose');
            disposables = [];
        };
    }

    return AmountStepViewModel;

});

